import 'css-chunksrc/client/scenes/optimizedGantt/scroll/scrollZone/styles.scss';export default {
  "scrollZone": "_scrollZone_1y2lv_1"
};